module.exports = __webpack_public_path__ + "components/country-flag/static/tj-4c009c916e4eafb0debdff42d2b7e07e.svg";